import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { PairIcon } from '@root/entities/pair/ui/common'
import { FavoriteStar } from '@root/features/favorite-pairs/ui/common/favorite-star'
import { PairHeadline } from '@root/features/pair/ui/mobile/pair-headline'
import { PairSubline } from '@root/features/pair/ui/mobile/pair-subline'
import { MarkerCapShortFormatted } from '@root/shared/core/format'

import { PairSearchItemMetrics } from './search-pair-item-metrics'

import type { PairModel } from '@root/entities/pair/atoms/reatom-pair'
import type { ClassNameProps } from '@root/shared/react'

type PairSearchItemProps = {
  pair: PairModel
  onClick?: (pair: PairModel) => void
} & ClassNameProps

export const PairSearchItem: React.FC<PairSearchItemProps> = ({
  pair,
  onClick,
  className,
}) => {
  const [marketCapUsd] = useAtom(pair.marketCapUsd)

  return (
    <Root className={className} onClick={() => onClick?.(pair)}>
      <Headline>
        <Favorite pair={pair} size={16} />
        <PairIcon pair={pair} size={40} providerSize={14} />
        <InfoBlock>
          <PairHeadline pair={pair} />
          <PairSubline pair={pair} />
        </InfoBlock>

        <MarketCap>
          <MarkerCapShortFormatted mcap={marketCapUsd} />
        </MarketCap>
      </Headline>
      <PairSearchItemMetrics pair={pair} />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  cursor: pointer;

  display: grid;
  align-items: center;

  border-radius: 12px;
  border: 1px solid var(--backgroundA-3);
  background: var(--background-2);

  &:hover {
    background: var(--background-3);
  }
`

const Favorite = styled(FavoriteStar)``

const Headline = styled.div`
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: center;
  padding-block: 3px;
  padding-inline: 8px 3px;
  gap: 4px;
`

const MarketCap = styled.div`
  color: var(--text-12);

  display: grid;
  align-items: center;

  height: 48px;
  padding-inline: 8px;

  border-radius: 10px;
  background: var(--appearanceA-3);

  /* Mobile/12 Bold */
  font-size: 12px;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
  white-space: nowrap;
`

const InfoBlock = styled.div`
  display: grid;
  gap: 4px;
  padding-inline: 4px;
`
